import { render, staticRenderFns } from "./MsgViewer.vue?vue&type=template&id=5902b4c8&scoped=true&"
import script from "./MsgViewer.vue?vue&type=script&lang=js&"
export * from "./MsgViewer.vue?vue&type=script&lang=js&"
import style0 from "./MsgViewer.vue?vue&type=style&index=0&id=5902b4c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5902b4c8",
  null
  
)

export default component.exports